<div class="mb-6 flex">
  <csl-skeleton class="my-[6px] size-[120px] flex-shrink-0 rounded-3xl" />
  <div class="flex w-full flex-col py-5 pl-4 pr-10">
    <csl-skeleton class="mb-3 h-5 w-[160px] rounded-xl" />
    <csl-skeleton class="mb-3 h-2 w-full rounded-xl" />
    <csl-skeleton class="mb-6 h-2 w-[320px] rounded-xl" />
    <csl-skeleton class="h-2 w-[140px] rounded-xl" />
  </div>
</div>
<div class="mb-6 flex">
  <csl-skeleton class="my-[6px] size-[120px] flex-shrink-0 rounded-3xl" />
  <div class="flex w-full flex-col py-5 pl-4 pr-10">
    <csl-skeleton class="mb-3 h-5 w-[160px] rounded-xl" />
    <csl-skeleton class="mb-3 h-2 w-full rounded-xl" />
    <csl-skeleton class="mb-6 h-2 w-[320px] rounded-xl" />
    <csl-skeleton class="h-2 w-[140px] rounded-xl" />
  </div>
</div>
<div class="flex">
  <csl-skeleton class="my-[6px] size-[120px] flex-shrink-0 rounded-3xl" />
  <div class="flex w-full flex-col py-5 pl-4 pr-10">
    <csl-skeleton class="mb-3 h-5 w-[160px] rounded-xl" />
    <csl-skeleton class="mb-3 h-2 w-full rounded-xl" />
    <csl-skeleton class="mb-6 h-2 w-[320px] rounded-xl" />
    <csl-skeleton class="h-2 w-[140px] rounded-xl" />
  </div>
</div>
